/**
 * Since feature flags can have more advanced values such as JSON or union
 * of string, we store the associated type definitions in this file.
 *
 * NOTE: For a boolean type, we explicitly assign the corresponding
 * values in the `defaults` file.
 */

// ─── CELS-1149-short-target-tipping-by-location-enabled ──────────────────────

export type TargetTippingByLocation = readonly string[];

// ─── CELS-1191-permanent-dynamic-tip-values ──────────────────────────────────

export type DynamicTips =
  | Readonly<{
      pickup?: readonly DynamicTip[];
      delivery?: readonly DynamicTip[];
      outpost?: readonly DynamicTip[];
      kiosk?: readonly DynamicTip[];
    }>
  | undefined;

type DynamicTip =
  | Readonly<{
      isDefault?: boolean;
      value?: number | 'CUSTOM';
    }>
  | undefined;

// ─── CELS-4498-product-details-carousel-variation ────────────────────────────

export type ProductDetailsCarouselVariation =
  | 'BASE_IMAGE_FIRST' // The base product image is displayed first, followed by other slides.
  | 'BASE_IMAGE_LAST' // Other slides are displayed first, followed by the base product image.
  | 'HIDE_BASE_IMAGE'; // The base product image is hidden. Only other slides are shown.

// ─── CELS-4651-momo-poc-restaurant-entity-id-mapping ────────────────────────
// The keys are the restaurant entity ids and the values are the momo outlet ids.

export type MomoOutletIdMapping = Record<string, string>;

// ─── CELS-4859-base-location-radius-config ───────────────────────────────────

export type BaseLocationRadiusConfig = {
  SMALLEST: number;
  SMALL: number;
  MEDIUM: number;
  LARGE: number;
};

// ─────────────────────────────────────────────────────────────────────────────

// ─── CELS-4828-order-payment-state-config ────────────────────────────────────

export type OrderPaymentStateConfig = {
  pollingInterval?: number;
  expirationTolerance?: number;
  delayedTolerance?: number;
};

// ─── permanent-stripe-payment-method-config ──────────────────────────────────

export type StripePaymentMethodConfig = {
  defaultId: string;
  pollingDisabledId: string;
};
